// Adds a ref=blockworks referrer to the link
const addRefParam = (link: string, ref: string = 'blockworks') => {
    return `${link}${link.indexOf('?') === -1 ? '?' : '&'}ref=${ref}`;
};
export default addRefParam;
